export default __webpack_public_path__ + "static/media/sean.d2c1352e.jpg";